import { type Bounds } from '@/shared/lib'

export const getBoundRange = (bounds: Bounds) => {
  const { y: swLat, x: swLng } = bounds.getMin()
  const { y: neLat, x: neLng } = bounds.getMax()

  return { swLat, swLng, neLat, neLng }
}
